import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-import-proc',
  templateUrl: './p2-import-proc.component.html',
  styleUrls: ['./p2-import-proc.component.css']
})
export class P2ImportProcComponent implements OnInit {
    p2ImportProcKeyno;

    public edit?: Edit;

    public selectListEncodingTypes: EncodingType[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2ImportProcKeyno = this.stateService.getStateParams()['p2_importproc_keyno'];
    }

    private async loadEdit() {
        if (!!this.p2ImportProcKeyno) {
            this.edit = (await this.datatask.Post(878, { p2_importproc_keyno: this.p2ImportProcKeyno }))[0];
        }
    }

    private async loadEncodingTypes() {
        this.selectListEncodingTypes = await this.datatask.Post(886);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(879, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadEncodingTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_importproc_keyno: string;
    importproc_name: string;
    filename: string;
    proc_name: string;
    encodingtype: string;
    must_run_sequentially: string;
    searchtext1: string;
    stop_on_error: string;
    show_table_name_destination: string;
    show_in_excelimport: string;
}

interface EncodingType {
    encodingtype: string;
    encodingtype_name: string;
    orderby: number;
}
